// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3qIzP","icon":"SortAdornment_icon__xsKqx","up":"SortAdornment_up__-HJAS","down":"SortAdornment_down__3O_Cm","active":"SortAdornment_active__2dkKu"};